module.exports = {
      id: "float-help-usage",
      viewBox: "0 0 60 60",
      url: __webpack_public_path__ + "images/js_src_vue/page_eagle_landing/sprite.b4f41d19.svg#float-help-usage",
      toString: function () {
        return this.url;
      }
    }